import { CabinetNameRule } from '../entities/CabinetNameRule';
import { CabinetSupport, PositionAngle, PaneMaterial } from '../constants';

export let cabinetNameRules: CabinetNameRule[] = [];

/* Cabinet name rules sorted by priority (highest to lowest) */

// Hanging cabinet: defined by support type
cabinetNameRules.push(
  new CabinetNameRule(
    'Hanging cabinet',
    cabinet =>
      cabinet.support === CabinetSupport.ToHangHook ||
      cabinet.support === CabinetSupport.ToHangScrew,
  ),
);

// Low cabinet: defined by only 1 shelf with only 1 rack
cabinetNameRules.push(
  new CabinetNameRule(
    'Low cabinet',
    cabinet =>
      cabinet.shelves.length === 1 && cabinet.shelf(0).racks.length === 1,
  ),
);

// Wardrobe: defined by min. 1 shelf with rod
cabinetNameRules.push(
  new CabinetNameRule('Wardrobe', cabinet => {
    for (const shelf of cabinet.shelves) {
      if (shelf.rod) return true;
    }
    return false;
  }),
);

// Shelf: defined by all shelves without doors
cabinetNameRules.push(
  new CabinetNameRule('Shelf', cabinet => {
    for (const shelf of cabinet.shelves) {
      if (shelf.doors && shelf.doors.length > 0) return false;
    }
    return true;
  }),
);

// Display cabinet: defined by min. 2 shelves with front doors in glass material
cabinetNameRules.push(
  new CabinetNameRule('Display cabinet', cabinet => {
    let nbShelvesInGlass = 0;
    for (const shelf of cabinet.shelves) {
      const leftDoor = shelf.getDoor(PositionAngle.FrontLeft);
      const rightDoor = shelf.getDoor(PositionAngle.FrontRight);
      if (
        leftDoor &&
        rightDoor &&
        leftDoor.material === PaneMaterial.Glass &&
        rightDoor.material === PaneMaterial.Glass
      )
        nbShelvesInGlass++;
    }
    return nbShelvesInGlass >= 2;
  }),
);
